import React from 'react';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import { withRouter } from 'react-router';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';

const GoToAssignmentsOverviewAction = ({ assignment, router, disabled }) => {
  return (
    <AccessibilityWrapper>
      <SingleAction
        disabled={disabled}
        iconName="notebook"
        onClick={() =>
          router.push(
            `${FYM_FRONTEND_URL}/${router.params.subject}/assignments/progress/${assignment.id}`,
          )
        }
      >
        Assignment Overview
      </SingleAction>
    </AccessibilityWrapper>
  );
};

export default withRouter(GoToAssignmentsOverviewAction);
